/*
 * Module for the assigning epc Codes to topics.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicResponse/topicAgentAssist/topicAgentAssistView",
  "modules/shared/epcMappingModal/epcMappingModalModule",
], function (Marionette, Messenger, TopicAgentAssistView, EpcMappingModalModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicAgentAssist";
      this.region = options.region;
    },
    show: function (epcMigrations) {
      this.view = new TopicAgentAssistView.topicAgentAssistView({ collection: epcMigrations });

      this.view.on(
        "itemview:delete",
        function (itemView) {
          Messenger.yesNoDialog(
            "topic.epc.deleteDialog",
            {
              yes: function () {
                const topicId = Messenger.reqres.request("current:topic:id");
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Topic EPC Category",
                  id: [topicId, itemView.model.id],
                  idType: ["Topic", "EPC Category"],
                  object: "Topic EPC Category",
                });
                epcMigrations.remove(itemView.model); //remove, do not use deleteModel since deletes are handled
                // differently
              },
            },
            this,
          );
        },
        this,
      );
      this.view.on(
        "itemview:edit:category",
        function (itemView) {
          const rootEpcGroup = Messenger.reqres.request("epc:codes");
          const topicId = Messenger.reqres.request("current:topic:id");
          Messenger.vent.trigger(
            "show:modal",
            EpcMappingModalModule,
            {
              model: itemView.model,
              attribute: "categoryId",
            },
            rootEpcGroup,
            {
              title: "topic.epc.title",
              closeButton: true,
              closeOnBackgroundClick: false,
              trackInteraction: {
                action: "Topic EPC Category",
                id: topicId,
                idType: "Topic",
                object: "Topic",
              },
            },
          );
        },
        this,
      );
      this.view.on(
        "itemview:edit:code",
        function (itemView) {
          const rootEpcGroup = Messenger.reqres.request("epc:code:values", itemView.model);
          const topicId = Messenger.reqres.request("current:topic:id");
          Messenger.vent.trigger(
            "show:modal",
            EpcMappingModalModule,
            {
              model: itemView.model,
              attribute: "code",
            },
            rootEpcGroup,
            {
              title: "topic.epc.title",
              closeButton: true,
              closeOnBackgroundClick: false,
              trackInteraction: {
                action: "Topic EPC Category Code",
                id: topicId,
                idType: "Topic",
                object: "Topic",
              },
            },
          );
        },
        this,
      );
      this.view.on(
        "add:code",
        function () {
          //create new migration
          epcMigrations.addMigration();
        },
        this,
      );

      this.showRegion(this.view);
    },
  });
});
